module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative h-96 ml-5 mr-5 mb-5"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "h-full"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('canvas', {
    ref: "statisticsStudentTaps",
    staticClass: "cursor-pointer"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-end space-x-2 h-full"
  }, [_c('div', {
    staticClass: "bg-gray-100 h-32 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-48 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-3/4 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-40 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-56 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-60 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-48 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-20 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-40 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-52 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-60 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-48 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-20 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-60 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-56 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-48 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-32 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-40 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-56 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-36 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-48 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-48 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-20 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-60 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-56 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-48 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-32 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-40 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-56 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-40 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-56 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-60 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-48 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-20 w-8 animate-pulse rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-100 h-40 w-8 animate-pulse rounded"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4cb74736!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/pages/Reports/VerbalCharts/SpeakingChart.vue
// module id = 2259
// module chunks = 61